'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDateRange = require('react-date-range');

var _reactHoc = require('@mindz/react-hoc');

var _dateFns = require('date-fns');

var _idx = require('idx');

var _idx2 = _interopRequireDefault(_idx);

var _config = require('./config');

var _DateRangePickerDefaultModule = require('./DateRangePicker.default.module.css');

var _DateRangePickerDefaultModule2 = _interopRequireDefault(_DateRangePickerDefaultModule);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var CalendarIcon = function CalendarIcon(props) {
  return _react2.default.createElement('svg', props, _react2.default.createElement('g', {
    fill: '#009FFD'
  }, _react2.default.createElement('path', {
    d: 'M15.375 12.903c.345 0 .625.942.625.597V3.75c0-1.378-1.121-2.5-2.5-2.5h-.813V.625a.625.625 0 1 0-1.25 0v.625H8.595V.625a.625.625 0 1 0-1.25 0v.625H4.53V.625a.625.625 0 1 0-1.25 0v.625H2.5A2.503 2.503 0 0 0 0 3.75v9.75C0 14.879 1.121 16 2.5 16h11c1.379 0 2.5-1.121 2.5-2.5a.625.625 0 1 0-1.25 0c0 .69-.56 1.25-1.25 1.25h-11c-.69 0-1.25-.56-1.25-1.25V3.75c0-.69.56-1.25 1.25-1.25h.781v.625a.625.625 0 1 0 1.25 0V2.5h2.813v.625a.625.625 0 1 0 1.25 0V2.5h2.844v.625a.625.625 0 1 0 1.25 0V2.5h.812c.69 0 1.25.56 1.25 1.25v10.185c0 .346.28-1.032.625-1.032z'
  }), _react2.default.createElement('circle', {
    cx: '3.906',
    cy: '6.563',
    r: '1',
    stroke: '#009FFD',
    strokeWidth: '.5'
  }), _react2.default.createElement('circle', {
    cx: '9.344',
    cy: '6.563',
    r: '1',
    stroke: '#009FFD',
    strokeWidth: '.5'
  }), _react2.default.createElement('circle', {
    cx: '12.063',
    cy: '6.563',
    r: '1',
    stroke: '#009FFD',
    strokeWidth: '.5'
  }), _react2.default.createElement('circle', {
    cx: '3.906',
    cy: '9.281',
    r: '1',
    stroke: '#009FFD',
    strokeWidth: '.5'
  }), _react2.default.createElement('circle', {
    cx: '3.906',
    cy: '12',
    r: '1',
    stroke: '#009FFD',
    strokeWidth: '.5'
  }), _react2.default.createElement('circle', {
    cx: '6.625',
    cy: '6.563',
    r: '1',
    stroke: '#009FFD',
    strokeWidth: '.5'
  }), _react2.default.createElement('circle', {
    cx: '6.625',
    cy: '9.281',
    r: '1',
    stroke: '#009FFD',
    strokeWidth: '.5'
  }), _react2.default.createElement('circle', {
    cx: '6.625',
    cy: '12',
    r: '1',
    stroke: '#009FFD',
    strokeWidth: '.5'
  }), _react2.default.createElement('circle', {
    cx: '9.344',
    cy: '9.281',
    r: '1',
    stroke: '#009FFD',
    strokeWidth: '.5'
  }), _react2.default.createElement('circle', {
    cx: '12.063',
    cy: '9.281',
    r: '1',
    stroke: '#009FFD',
    strokeWidth: '.5'
  }), _react2.default.createElement('circle', {
    cx: '9.344',
    cy: '12',
    r: '1',
    stroke: '#009FFD',
    strokeWidth: '.5'
  })));
};

CalendarIcon.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16'
};

var DeleteIcon = function DeleteIcon(props) {
  return _react2.default.createElement('svg', props, _react2.default.createElement('defs', null, _react2.default.createElement('path', {
    id: 'a',
    d: 'M0 0h30v30H0z'
  })), _react2.default.createElement('g', {
    fill: 'none',
    fillRule: 'evenodd'
  }, _react2.default.createElement('mask', {
    id: 'b',
    fill: '#fff'
  }, _react2.default.createElement('use', {
    xlinkHref: '#a'
  })), _react2.default.createElement('path', {
    fill: '#c0c2cc',
    d: 'M16.414 15l2.122 2.121a1 1 0 0 1-1.415 1.415L15 16.414l-2.121 2.122a1 1 0 0 1-1.415-1.415L13.586 15l-2.122-2.121a1 1 0 0 1 1.415-1.415L15 13.586l2.121-2.122a1 1 0 0 1 1.415 1.415L16.414 15zM15 26C8.925 26 4 21.075 4 15S8.925 4 15 4s11 4.925 11 11-4.925 11-11 11zm0-2a9 9 0 1 0 0-18 9 9 0 0 0 0 18z',
    mask: 'url(#b)'
  })));
};

DeleteIcon.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  xmlnsXlink: 'http://www.w3.org/1999/xlink',
  width: '30',
  height: '30',
  viewBox: '0 0 30 30'
};
var UI = Object.freeze({
  DROPDOWN: 'dropdown',
  INPUT: 'input'
});

var DateRangePickerComponent = function (_Component) {
  _inherits(DateRangePickerComponent, _Component);

  function DateRangePickerComponent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DateRangePickerComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DateRangePickerComponent.__proto__ || Object.getPrototypeOf(DateRangePickerComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectionRange: {
        startDate: _config.defineds.startOfToday,
        endDate: _config.defineds.endOfToday,
        key: 'selection'
      },
      isCalendarShown: false,
      rangeString: ''
    }, _this.lastDifferenceInDays = null, _this.handleOutsideClick = function (event) {
      if (_this.node && !_this.node.contains(event.target)) {
        _this.lastDifferenceInDays = null;

        _this.setState({
          isCalendarShown: false
        });
      }
    }, _this.renderInput = function () {
      var _this$props = _this.props,
          cx = _this$props.cx,
          type = _this$props.type,
          label = _this$props.label,
          hideResetButton = _this$props.hideResetButton;
      var rangeString = _this.state.rangeString;

      if (type === UI.DROPDOWN) {
        return _react2.default.createElement('div', {
          className: cx('indicator'),
          onClick: _this.toggleCalendar
        }, !hideResetButton && rangeString && _react2.default.createElement('div', {
          className: cx('reset'),
          onClick: _this.handleResetClick
        }, _react2.default.createElement(DeleteIcon, {
          className: cx('reset-icon')
        })), rangeString || label);
      }

      if (type === UI.INPUT) {
        return _react2.default.createElement('div', {
          className: cx('inputField'),
          onClick: _this.toggleCalendar
        }, _react2.default.createElement('div', {
          className: cx('title')
        }, _react2.default.createElement('span', {
          className: cx('text')
        }, rangeString), _react2.default.createElement('span', {
          className: cx('label')
        }, label), !hideResetButton && rangeString && _react2.default.createElement('div', {
          className: cx('reset'),
          onClick: _this.handleResetClick
        })), _react2.default.createElement(CalendarIcon, {
          className: cx('calendarIcon')
        }));
      }

      return null;
    }, _this.handleResetClick = function (event) {
      var handleReset = _this.props.handleReset;
      handleReset && handleReset(event);

      _this.setState({
        selectionRange: {
          startDate: _config.defineds.startOfToday,
          endDate: _config.defineds.endOfToday,
          key: 'selection'
        },
        isCalendarShown: false,
        rangeString: ''
      });
    }, _this.renderError = function () {
      var _this$props2 = _this.props,
          error = _this$props2.error,
          cx = _this$props2.cx;
      return _react2.default.createElement('div', {
        className: cx('error', {
          shown: error
        })
      }, error);
    }, _this.toggleCalendar = function () {
      var isCalendarShown = _this.state.isCalendarShown;

      _this.setState({
        isCalendarShown: !isCalendarShown
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DateRangePickerComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          handleChange = _props.handleChange,
          isReturnInitialDate = _props.isReturnInitialDate,
          startDate = _props.startDate,
          endDate = _props.endDate,
          isShownInitialDate = _props.isShownInitialDate;

      if (startDate && endDate) {
        var start = (0, _dateFns.format)(startDate, _config.dateFormat);
        var end = (0, _dateFns.format)(endDate, _config.dateFormat);
        var rangeString = isShownInitialDate ? start + ' - ' + end : '';
        this.setState({
          selectionRange: {
            startDate: startDate,
            endDate: endDate,
            key: 'selection'
          },
          rangeString: rangeString
        });
      }

      if (isReturnInitialDate) {
        var _state$selectionRange = this.state.selectionRange,
            _startDate = _state$selectionRange.startDate,
            _endDate = _state$selectionRange.endDate;
        handleChange && handleChange({
          start: (0, _dateFns.format)(_startDate, _config.dateFormat),
          end: (0, _dateFns.format)(_endDate, _config.dateFormat)
        });
      }

      document.addEventListener('click', this.handleOutsideClick, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }
  }, {
    key: 'handleSelect',
    value: function handleSelect(_ref2) {
      var selection = _ref2.selection;
      var handleChange = this.props.handleChange;

      if (selection) {
        var startDate = selection.startDate,
            endDate = selection.endDate;
        var diffDays = Math.abs((0, _dateFns.differenceInDays)(endDate, startDate));
        var isFirstClickOnDay = diffDays === 0 && this.lastDifferenceInDays !== 0;
        this.lastDifferenceInDays = isFirstClickOnDay ? diffDays : null;
        var start = (0, _dateFns.format)(startDate, _config.dateFormat);
        var end = (0, _dateFns.format)(endDate, _config.dateFormat);
        var rangeString = start + ' - ' + end;
        this.setState({
          selectionRange: selection,
          isCalendarShown: isFirstClickOnDay,
          rangeString: rangeString
        }, function () {
          handleChange && handleChange({
            start: start,
            end: end
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          cx = _props2.cx,
          align = _props2.align,
          error = _props2.error,
          minDate = _props2.minDate,
          maxDate = _props2.maxDate,
          zIndex = _props2.zIndex,
          staticRanges = _props2.staticRanges,
          shownDate = _props2.shownDate;
      var _state = this.state,
          selectionRange = _state.selectionRange,
          isCalendarShown = _state.isCalendarShown,
          rangeString = _state.rangeString;
      return _react2.default.createElement('div', {
        className: cx('root', {
          active: isCalendarShown,
          selected: !!rangeString,
          hasError: !!error
        }),
        ref: function ref(node) {
          return _this2.node = node;
        }
      }, this.renderInput(), this.renderError(), isCalendarShown && _react2.default.createElement('div', {
        className: cx('dateRangeWrapper', [align]),
        style: {
          zIndex: zIndex
        }
      }, _react2.default.createElement(_reactDateRange.DateRangePicker, {
        ranges: [selectionRange],
        onChange: this.handleSelect.bind(this),
        locale: _config.locale,
        staticRanges: staticRanges,
        inputRanges: [],
        showMonthAndYearPickers: false,
        minDate: minDate,
        maxDate: maxDate,
        shownDate: shownDate
      })));
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var newSelectionRange = (0, _idx2.default)(nextProps, function (_) {
        return _.ranges[0];
      });

      if (newSelectionRange && newSelectionRange.startDate && newSelectionRange.endDate && (newSelectionRange.startDate !== prevState.selectionRange.startDate || newSelectionRange.endDate !== prevState.selectionRange.endDate)) {
        var start = (0, _dateFns.format)(newSelectionRange.startDate, _config.dateFormat);
        var end = (0, _dateFns.format)(newSelectionRange.endDate, _config.dateFormat);
        return {
          selectionRange: newSelectionRange,
          rangeString: start + ' - ' + end
        };
      }

      return null;
    }
  }]);

  return DateRangePickerComponent;
}(_react.Component);

DateRangePickerComponent.defaultProps = {
  type: UI.DROPDOWN,
  align: 'left',
  label: 'Ramy czasowe',
  isReturnInitialDate: true,
  isShownInitialDate: true,
  minDate: undefined,
  maxDate: undefined,
  zIndex: 5,
  hideResetButton: false,
  staticRanges: _config.staticRanges
};
DateRangePickerComponent.propTypes = {
  type: _propTypes2.default.oneOf([UI.DROPDOWN, UI.INPUT]),
  align: _propTypes2.default.oneOf(['left', 'right']),
  staticRanges: _propTypes2.default.array.isRequired,
  label: _propTypes2.default.string,
  handleChange: _propTypes2.default.func,
  handleReset: _propTypes2.default.func,
  hideResetButton: _propTypes2.default.bool,
  ranges: _propTypes2.default.arrayOf(_propTypes2.default.object)
};
var enhanced = (0, _reactHoc.withStyles)(_DateRangePickerDefaultModule2.default)(DateRangePickerComponent);
enhanced.defineds = _config.defineds;
exports.default = enhanced;
module.exports = exports.default;